
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3258',
  depVersions: {
  "customer-portal-app": "static-1.3258",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.503",
  "data-fetching-client": "static-1.10036",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26341",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5978",
  "hs-test-utils": "static-1.8425",
  "hub-http": "static-1.6600",
  "hub-http-shared-msw-handlers": "static-1.10755",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19130",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11878",
  "I18n": "static-7.1688",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6837",
  "payment-link-components": "static-1.24282",
  "portals-platform-bend-plugin": "static-1.25",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7557",
  "quartz-core": "static-1.6776",
  "quartz-i18n": "static-1.1232",
  "react": "static-7.202",
  "react-colorpicker": "static-2.10602",
  "react-dlb": "static-1.92",
  "react-utils": "static-2.5609",
  "reselect": "static-3.15",
  "rich-text-lib": "static-1.20428",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18482",
  "ui-components-test-utils": "static-1.6015",
  "UIComponents": "static-3.8824",
  "foundations-assets": "static-1.5277",
  "foundations-components": "static-1.8619",
  "foundations-theming": "static-1.4868",
  "foundations-theming-specialty": "static-1.2584",
  "framer-motion": "static-1.82",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1587",
  "quartz-config": "static-1.1335",
  "quartz-routing": "static-1.987",
  "quick-fetch": "static-1.4178",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17117",
  "rpc-client-utils": "static-1.5055",
  "sanitize-text": "static-1.8547",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.64",
  "ui-addon-draggable": "static-3.5135",
  "ui-addon-react-router-dom": "static-1.9918",
  "usage-tracker": "static-1.7701",
  "usage-tracker-anonymous": "static-1.6118",
  "usage-tracker-core": "static-1.7551",
  "video-components-external": "static-1.12288",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3834",
  "quartz-webpack": "static-1.3781",
  "bend-plugin-quartz-routing": "static-1.635",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.92",
  "customer-data-objects": "static-1.8080",
  "frontend-preferences-client": "static-1.8310",
  "laboratory-lib": "static-3.7540",
  "onboarding-scopes": "static-1.6842",
  "seat-types-lib": "static-1.886",
  "ui-addon-opt": "static-4.8753",
  "HeadJS": "static-2.809",
  "hs-test-utils-bend-plugin": "static-1.3536",
  "msw": "static-1.39",
  "msw-config": "static-1.14",
  "testing-library": "static-1.162",
  "hs-locale-management": "static-1.348",
  "ts-schema": "static-1.4348",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8306",
  "content-media-capture": "static-1.5612",
  "cssUtils": "static-1.1010",
  "customer-data-ui-utilities": "static-1.10220",
  "file-manager-components": "static-1.24670",
  "HubStyle": "static-2.12185",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3278",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.511",
  "ui-addon-emoji-picker": "static-1.10258",
  "ui-addon-i18n": "static-1.11538",
  "ui-business-units-lib": "static-1.9483",
  "ui-shepherd-react": "static-3.10660",
  "video-data-lib": "static-1.35946",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4699",
  "commerce-tours-lib": "static-1.6739",
  "customer-data-properties": "static-1.52816",
  "getting-started-shared-tasks": "static-1.19400",
  "growth-onboarding-reliability": "static-1.5472",
  "onboarding-tours": "static-1.17260",
  "reference-resolvers-lite": "static-1.8492",
  "sales-checkout-service-client": "static-1.3919",
  "ui-addon-iframeable": "static-1.9467",
  "user-context": "static-1.5473",
  "bender-build-tools": "static-1.3452",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.895",
  "hubspotter-http": "static-1.4913",
  "icons": "static-2.696",
  "mobile-manifest-mixins": "static-1.590",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.549",
  "quartz-auth": "static-1.1232",
  "quartz-head": "static-1.1222",
  "quartz-test": "static-1.1232",
  "quartz-tracking": "static-1.936",
  "trellis-components": "static-1.2890",
  "ui-fonts": "static-1.1140",
  "usage-tracker-container": "static-1.7691",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9814",
  "data-token-picker": "static-1.17003",
  "FileManagerLib": "static-1.40310",
  "property-translator": "static-1.5770",
  "merchandise-lib": "static-1.282",
  "purchase-motions-components": "static-1.6529",
  "SharedI18nStrings": "static-1.186",
  "foundations-components-test-utils": "static-1.6102",
  "react-create-root-preference": "static-1.86",
  "react-select-plus": "static-1.116",
  "react-virtualized": "static-2.110",
  "ui-images": "static-2.1266",
  "bend-plugin-foundations-components": "static-1.4888",
  "floating-ui": "static-1.66",
  "react-aria": "static-1.75",
  "trellis-assets": "static-1.2871",
  "bend-plugin-foundations-theming": "static-1.3351",
  "foundations-theming-base": "static-1.3853",
  "stylex": "static-1.45",
  "pdf-js": "static-2.49",
  "interframe": "static-3.5131",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6115",
  "opentelemetry-fe-types": "static-1.174",
  "web-vitals": "static-1.18",
  "bend-plugin-chirp-manifest": "static-1.465",
  "chirp-fetch": "static-1.2289",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4860",
  "react-flip-move": "static-1.81",
  "apollo-link-hub-http": "static-2.5013",
  "content-media-composition-data-lib": "static-1.13416",
  "content-media-compositions": "static-2.17423",
  "idb-keyval": "static-1.54",
  "immer": "static-1.104",
  "immerable": "static-1.4533",
  "magpie-lib": "static-1.5826",
  "magpie-types": "static-1.5286",
  "media-bridge-lib": "static-1.19519",
  "inbound-db-properties-service-client": "static-1.4097",
  "superstore": "static-1.5149",
  "feedback-loader": "static-1.29928",
  "ai-components-ui-library": "static-1.9876",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29454",
  "ContentUtils": "static-1.69294",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4813",
  "sassPrefix": "static-1.278",
  "react-dnd-compat": "static-1.5003",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1948",
  "copilot-toolkit": "static-1.11989",
  "poll-commands": "static-1.3861",
  "atom": "static-1.5469",
  "avatar-components": "static-1.2871",
  "navigation-messaging": "static-1.8314",
  "redux-thunk": "static-2.83",
  "reference-resolvers": "static-1.8571",
  "commerce-products-lib": "static-1.10704",
  "crm-message-bus": "static-1.43926",
  "growth-data-modal": "static-1.6007",
  "hubspot-apollo-client": "static-1.5264",
  "onboarding-tours-client": "static-1.5475",
  "batch-promise": "static-1.1935",
  "calling-global-api": "static-1.65883",
  "calling-internal-common": "static-1.31711",
  "calling-lifecycle-internal": "static-1.67265",
  "calling-lifecycle-messages": "static-1.59558",
  "conditional-properties-service-client": "static-1.4070",
  "crm-index-visualization-core": "static-1.4643",
  "crm-links": "static-1.6690",
  "crm-pipelines-api-client-types": "static-1.4400",
  "customer-data-objects-ui-components": "static-1.13419",
  "customer-data-properties-shared-msw-handlers": "static-1.10082",
  "customer-data-property-utils": "static-1.8458",
  "external-options-client-types": "static-1.4395",
  "formula-editor": "static-1.14893",
  "framework-data-schema-resolvers": "static-1.7284",
  "google-libphonenumber": "static-1.48",
  "hs-resources": "static-1.582",
  "inbound-db-meta-service-client": "static-1.3726",
  "inbounddb-objects-service-types": "static-1.4478",
  "meetings-icalendar-utils-lib": "static-1.1025",
  "multi-currency-client-types": "static-1.3964",
  "object-builder-ui-client": "static-1.49855",
  "pipeline-validation-client-types": "static-1.4237",
  "property-value-citations": "static-1.3430",
  "pulse": "static-1.1023",
  "smart-data-capture-core": "static-1.281",
  "smart-property-lib": "static-1.8468",
  "tiered-pricing": "static-1.2090",
  "topics-actions-lib": "static-1.562",
  "trial-components-library": "static-1.14242",
  "ui-addon-form-validation": "static-1.11334",
  "zustand": "static-1.86",
  "growth-onboarding-confetti": "static-1.3453",
  "growth-onboarding-next-action-utils": "static-1.2836",
  "navigation-components": "static-1.18987",
  "onboarding-tours-utils": "static-1.1327",
  "ui-shepherd-tracker": "static-1.8041",
  "ui-universal-auth": "static-1.9568",
  "getting-started-shared-tasks-store": "static-1.18518",
  "beacon-keepalive-queue": "static-1.92",
  "opentelemetry-web": "static-1.18",
  "hubspotter-http-shared-msw-handlers": "static-1.10753",
  "usage-tracker-session-replay": "static-1.5387",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "trellis-theming": "static-1.1366",
  "tanstack-virtual": "static-1.41",
  "audio-components": "static-1.6454",
  "FileManagerCore": "static-1.40169",
  "FileManagerImages": "static-1.37821",
  "video-components": "static-1.14290",
  "foundations-components-legacy": "static-1.1644",
  "purchase-motions-api": "static-1.6532",
  "signup-constants": "static-1.19761",
  "signup-ui-url-generator": "static-2.8447",
  "stylex-utils": "static-1.155",
  "usage-tracker-public": "static-1.7512",
  "reactive-lib": "static-1.1110",
  "simple-logging-lib": "static-1.3442",
  "nudge-client-utils": "static-1.3271",
  "chatspot-core": "static-1.23367",
  "growth-onboarding-feedback-components": "static-1.6975",
  "cms-field-types": "static-1.5200",
  "content-icons-ui": "static-1.2412",
  "integrations-lib": "static-1.17237",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.926",
  "breeze-engine-core": "static-1.1226",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1165",
  "customer-data-tracking": "static-1.7261",
  "products-iframe-lib": "static-1.8731",
  "products-ui-components-shared-msw-handlers": "static-1.11137",
  "restore-request-side-panel-lib": "static-1.1850",
  "onboarding-data-sync-lib": "static-1.2690",
  "hubspot-apollo-cache": "static-1.723",
  "calling-error-reporting": "static-1.31718",
  "shared-worker-versioning": "static-1.11429",
  "calling-usage-tracker": "static-1.6925",
  "voice-sms-access-library": "static-1.2249",
  "conversations-skeleton-state": "static-1.7602",
  "crm-index-associations-lib": "static-1.6835",
  "framework-data-schema-quick-fetch": "static-1.7189",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10838",
  "redux-toolkit": "static-1.81",
  "sales-views-client-types": "static-1.4646",
  "location-customization-utils-lib": "static-1.10259",
  "bark-lib": "static-1.16919",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6277",
  "react-codemirror": "static-1.11030",
  "fdsr-migration-layer": "static-1.403",
  "framework-builder-read-service-client": "static-1.4275",
  "persist-promise": "static-1.4092",
  "event-emitter": "static-1.1348",
  "bend-plugin-pulse": "static-1.526",
  "fast-json-patch": "static-1.73",
  "data-agent-kit": "static-1.762",
  "fsm": "static-1.4142",
  "policy-lib": "static-1.7195",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10901",
  "embedded-academy-lib": "static-1.15741",
  "hubs-service-types": "static-1.1651",
  "salesImages": "static-1.651",
  "growth-onboarding-next-action-components": "static-1.2864",
  "user-context-client": "static-1.4898",
  "nest": "static-1.625",
  "unified-auth-core-lib": "static-1.1364",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.598",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4907",
  "video-embed": "static-1.36780",
  "social-insights-client-types": "static-1.22779",
  "nudge-custom-function-registry": "static-1.3028",
  "nudge-renderer-utils": "static-1.3347",
  "whisper-core-api": "static-1.7481",
  "flux-actions": "static-1.377",
  "integrations-error-boundary-lib": "static-1.14652",
  "integrations-tracking-lib": "static-1.6000",
  "native-integrations-shared-strings": "static-1.8153",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10760",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1082",
  "InboxConnectUtils": "static-4.15699",
  "meetings-connect-utils-lib": "static-1.8003",
  "calling-orchestration-schema": "static-1.37026",
  "crm-record-cards-service-types": "static-1.3823",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16511",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.114",
  "trellis-story-utils": "static-1.4896",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15201",
  "outpost": "static-1.4526",
  "universal-page-editor-lib": "static-1.3399",
  "adobe-sign-auth-lib": "static-1.615",
  "ads-unified-auth-lib": "static-1.1654",
  "custom-vendor-connection-lib": "static-1.132",
  "google-sheets-integration-lib": "static-1.1179",
  "microsoft-drive-auth-lib": "static-1.333",
  "surveymonkey-integration-lib": "static-1.682",
  "slack-ui-library": "static-1.10787",
  "hub-http-contrib": "static-1.3415",
  "ui-addon-sales-email": "static-1.5592",
  "academy-service-client": "static-1.4081",
  "croppie": "static-2.10",
  "final-form": "static-1.81",
  "SafeStorage": "static-1.4783",
  "trellis-ecosystem": "static-1.7733",
  "wootric-nps": "static-1.7250",
  "marketplace-ui-apps-core": "static-1.19433",
  "marketplace-ui-common": "static-1.20901",
  "developer-experience-shared-components": "static-1.10926",
  "immutable-less": "static-1.5039",
  "marketplace-ui-client-types": "static-1.18308",
  "ui-addon-integrations-directory-panel": "static-2.8383",
  "ui-extensibility-client-types": "static-1.4306",
  "ai-settings-ui-library": "static-1.8453",
  "nav-meta": "static-1.30624",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1330",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "settings-ui-lib": "static-1.12914",
  "simple-data-table": "static-1.3662"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3258",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.503",
  "data-fetching-client": "/data-fetching-client/static-1.10036",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26341",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5978",
  "hs-test-utils": "/hs-test-utils/static-1.8425",
  "hub-http": "/hub-http/static-1.6600",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10755",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19130",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11878",
  "I18n": "/I18n/static-7.1688",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6837",
  "payment-link-components": "/payment-link-components/static-1.24282",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.25",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7557",
  "quartz-core": "/quartz-core/static-1.6776",
  "quartz-i18n": "/quartz-i18n/static-1.1232",
  "react": "/react/static-7.202",
  "react-colorpicker": "/react-colorpicker/static-2.10602",
  "react-dlb": "/react-dlb/static-1.92",
  "react-utils": "/react-utils/static-2.5609",
  "reselect": "/reselect/static-3.15",
  "rich-text-lib": "/rich-text-lib/static-1.20428",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18482",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6015",
  "UIComponents": "/UIComponents/static-3.8824",
  "foundations-assets": "/foundations-assets/static-1.5277",
  "foundations-components": "/foundations-components/static-1.8619",
  "foundations-theming": "/foundations-theming/static-1.4868",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2584",
  "framer-motion": "/framer-motion/static-1.82",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1587",
  "quartz-config": "/quartz-config/static-1.1335",
  "quartz-routing": "/quartz-routing/static-1.987",
  "quick-fetch": "/quick-fetch/static-1.4178",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17117",
  "rpc-client-utils": "/rpc-client-utils/static-1.5055",
  "sanitize-text": "/sanitize-text/static-1.8547",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.64",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5135",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9918",
  "usage-tracker": "/usage-tracker/static-1.7701",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6118",
  "usage-tracker-core": "/usage-tracker-core/static-1.7551",
  "video-components-external": "/video-components-external/static-1.12288",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3834",
  "quartz-webpack": "/quartz-webpack/static-1.3781",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.635",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.92",
  "customer-data-objects": "/customer-data-objects/static-1.8080",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8310",
  "laboratory-lib": "/laboratory-lib/static-3.7540",
  "onboarding-scopes": "/onboarding-scopes/static-1.6842",
  "seat-types-lib": "/seat-types-lib/static-1.886",
  "ui-addon-opt": "/ui-addon-opt/static-4.8753",
  "HeadJS": "/HeadJS/static-2.809",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3536",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.14",
  "testing-library": "/testing-library/static-1.162",
  "hs-locale-management": "/hs-locale-management/static-1.348",
  "ts-schema": "/ts-schema/static-1.4348",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8306",
  "content-media-capture": "/content-media-capture/static-1.5612",
  "cssUtils": "/cssUtils/static-1.1010",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10220",
  "file-manager-components": "/file-manager-components/static-1.24670",
  "HubStyle": "/HubStyle/static-2.12185",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3278",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10258",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11538",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9483",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10660",
  "video-data-lib": "/video-data-lib/static-1.35946",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4699",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6739",
  "customer-data-properties": "/customer-data-properties/static-1.52816",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19400",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5472",
  "onboarding-tours": "/onboarding-tours/static-1.17260",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8492",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3919",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9467",
  "user-context": "/user-context/static-1.5473",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hubspotter-http": "/hubspotter-http/static-1.4913",
  "icons": "/icons/static-2.696",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.590",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.549",
  "quartz-auth": "/quartz-auth/static-1.1232",
  "quartz-head": "/quartz-head/static-1.1222",
  "quartz-test": "/quartz-test/static-1.1232",
  "quartz-tracking": "/quartz-tracking/static-1.936",
  "trellis-components": "/trellis-components/static-1.2890",
  "ui-fonts": "/ui-fonts/static-1.1140",
  "usage-tracker-container": "/usage-tracker-container/static-1.7691",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9814",
  "data-token-picker": "/data-token-picker/static-1.17003",
  "FileManagerLib": "/FileManagerLib/static-1.40310",
  "property-translator": "/property-translator/static-1.5770",
  "merchandise-lib": "/merchandise-lib/static-1.282",
  "purchase-motions-components": "/purchase-motions-components/static-1.6529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6102",
  "react-create-root-preference": "/react-create-root-preference/static-1.86",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-virtualized": "/react-virtualized/static-2.110",
  "ui-images": "/ui-images/static-2.1266",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4888",
  "floating-ui": "/floating-ui/static-1.66",
  "react-aria": "/react-aria/static-1.75",
  "trellis-assets": "/trellis-assets/static-1.2871",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3351",
  "foundations-theming-base": "/foundations-theming-base/static-1.3853",
  "stylex": "/stylex/static-1.45",
  "pdf-js": "/pdf-js/static-2.49",
  "interframe": "/interframe/static-3.5131",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6115",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.174",
  "web-vitals": "/web-vitals/static-1.18",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.465",
  "chirp-fetch": "/chirp-fetch/static-1.2289",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4860",
  "react-flip-move": "/react-flip-move/static-1.81",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5013",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13416",
  "content-media-compositions": "/content-media-compositions/static-2.17423",
  "idb-keyval": "/idb-keyval/static-1.54",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4533",
  "magpie-lib": "/magpie-lib/static-1.5826",
  "magpie-types": "/magpie-types/static-1.5286",
  "media-bridge-lib": "/media-bridge-lib/static-1.19519",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4097",
  "superstore": "/superstore/static-1.5149",
  "feedback-loader": "/feedback-loader/static-1.29928",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9876",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29454",
  "ContentUtils": "/ContentUtils/static-1.69294",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4813",
  "sassPrefix": "/sassPrefix/static-1.278",
  "react-dnd-compat": "/react-dnd-compat/static-1.5003",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1948",
  "copilot-toolkit": "/copilot-toolkit/static-1.11989",
  "poll-commands": "/poll-commands/static-1.3861",
  "atom": "/atom/static-1.5469",
  "avatar-components": "/avatar-components/static-1.2871",
  "navigation-messaging": "/navigation-messaging/static-1.8314",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reference-resolvers": "/reference-resolvers/static-1.8571",
  "commerce-products-lib": "/commerce-products-lib/static-1.10704",
  "crm-message-bus": "/crm-message-bus/static-1.43926",
  "growth-data-modal": "/growth-data-modal/static-1.6007",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5264",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5475",
  "batch-promise": "/batch-promise/static-1.1935",
  "calling-global-api": "/calling-global-api/static-1.65883",
  "calling-internal-common": "/calling-internal-common/static-1.31711",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67265",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59558",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4070",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4643",
  "crm-links": "/crm-links/static-1.6690",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4400",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13419",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10082",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8458",
  "external-options-client-types": "/external-options-client-types/static-1.4395",
  "formula-editor": "/formula-editor/static-1.14893",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7284",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "hs-resources": "/hs-resources/static-1.582",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3726",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4478",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1025",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3964",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49855",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4237",
  "property-value-citations": "/property-value-citations/static-1.3430",
  "pulse": "/pulse/static-1.1023",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.281",
  "smart-property-lib": "/smart-property-lib/static-1.8468",
  "tiered-pricing": "/tiered-pricing/static-1.2090",
  "topics-actions-lib": "/topics-actions-lib/static-1.562",
  "trial-components-library": "/trial-components-library/static-1.14242",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11334",
  "zustand": "/zustand/static-1.86",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3453",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2836",
  "navigation-components": "/navigation-components/static-1.18987",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1327",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8041",
  "ui-universal-auth": "/ui-universal-auth/static-1.9568",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18518",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.92",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10753",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5387",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "trellis-theming": "/trellis-theming/static-1.1366",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "audio-components": "/audio-components/static-1.6454",
  "FileManagerCore": "/FileManagerCore/static-1.40169",
  "FileManagerImages": "/FileManagerImages/static-1.37821",
  "video-components": "/video-components/static-1.14290",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1644",
  "purchase-motions-api": "/purchase-motions-api/static-1.6532",
  "signup-constants": "/signup-constants/static-1.19761",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8447",
  "stylex-utils": "/stylex-utils/static-1.155",
  "usage-tracker-public": "/usage-tracker-public/static-1.7512",
  "reactive-lib": "/reactive-lib/static-1.1110",
  "simple-logging-lib": "/simple-logging-lib/static-1.3442",
  "nudge-client-utils": "/nudge-client-utils/static-1.3271",
  "chatspot-core": "/chatspot-core/static-1.23367",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6975",
  "cms-field-types": "/cms-field-types/static-1.5200",
  "content-icons-ui": "/content-icons-ui/static-1.2412",
  "integrations-lib": "/integrations-lib/static-1.17237",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.926",
  "breeze-engine-core": "/breeze-engine-core/static-1.1226",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1165",
  "customer-data-tracking": "/customer-data-tracking/static-1.7261",
  "products-iframe-lib": "/products-iframe-lib/static-1.8731",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11137",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1850",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2690",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.723",
  "calling-error-reporting": "/calling-error-reporting/static-1.31718",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11429",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6925",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2249",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6835",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7189",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10838",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "sales-views-client-types": "/sales-views-client-types/static-1.4646",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10259",
  "bark-lib": "/bark-lib/static-1.16919",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6277",
  "react-codemirror": "/react-codemirror/static-1.11030",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.403",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4275",
  "persist-promise": "/persist-promise/static-1.4092",
  "event-emitter": "/event-emitter/static-1.1348",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.526",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "data-agent-kit": "/data-agent-kit/static-1.762",
  "fsm": "/fsm/static-1.4142",
  "policy-lib": "/policy-lib/static-1.7195",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10901",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15741",
  "hubs-service-types": "/hubs-service-types/static-1.1651",
  "salesImages": "/salesImages/static-1.651",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2864",
  "user-context-client": "/user-context-client/static-1.4898",
  "nest": "/nest/static-1.625",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1364",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.598",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4907",
  "video-embed": "/video-embed/static-1.36780",
  "social-insights-client-types": "/social-insights-client-types/static-1.22779",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3028",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3347",
  "whisper-core-api": "/whisper-core-api/static-1.7481",
  "flux-actions": "/flux-actions/static-1.377",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14652",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6000",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8153",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10760",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1082",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15699",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8003",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37026",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3823",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16511",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.114",
  "trellis-story-utils": "/trellis-story-utils/static-1.4896",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15201",
  "outpost": "/outpost/static-1.4526",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3399",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.615",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1654",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.132",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1179",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.333",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.682",
  "slack-ui-library": "/slack-ui-library/static-1.10787",
  "hub-http-contrib": "/hub-http-contrib/static-1.3415",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5592",
  "academy-service-client": "/academy-service-client/static-1.4081",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.81",
  "SafeStorage": "/SafeStorage/static-1.4783",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7733",
  "wootric-nps": "/wootric-nps/static-1.7250",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19433",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20901",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10926",
  "immutable-less": "/immutable-less/static-1.5039",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18308",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8383",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4306",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8453",
  "nav-meta": "/nav-meta/static-1.30624",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1330",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "settings-ui-lib": "/settings-ui-lib/static-1.12914",
  "simple-data-table": "/simple-data-table/static-1.3662"
}
};
